import { render, staticRenderFns } from "./CheckboxVertical.vue?vue&type=template&id=6b1bb1f6&scoped=true&"
import script from "./CheckboxVertical.vue?vue&type=script&lang=js&"
export * from "./CheckboxVertical.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxVertical.vue?vue&type=style&index=0&id=6b1bb1f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1bb1f6",
  null
  
)

export default component.exports